import HintApi from '@/api/hint'

const createHintAction = async (_, payload) => {
  await HintApi.createHint(payload) // must have slideId & presentationId
}

export default {
  createHintAction,
}
